import { AuthGuard } from 'app/auth/auth.guard';
import { AccountingComponent } from 'app/main/accounting/accounting.component';
import { AccountingResolver } from 'app/main/accounting/accounting.resolver';
import { AnalyticsComponent } from 'app/main/analytics/analytics.component';
import { AnalyticsResolver } from 'app/main/analytics/analytics.resolver';
import { ChartsExpensesComponent } from 'app/main/charts/charts-expenses/charts-expenses.component';
import { ChartsRevenueComponent } from 'app/main/charts/charts-revenue/charts-revenue.component';
import { ChartsComponent } from 'app/main/charts/charts.component';
import { ChartsResolver } from 'app/main/charts/charts.resolver';
import { CompanyComponent } from 'app/main/company/company.component';
import { CompanyResolver } from 'app/main/company/company.resolver';
import { CubeComponent } from 'app/main/cube/cube.component';
import { CubeResolver } from 'app/main/cube/cube.resolver';
import { CustomerComponent } from 'app/main/customer/customer.component';
import { CustomerResolver } from 'app/main/customer/customer.resolver';
import { DashboardComponent } from 'app/main/dashboard/dashboard.component';
import { JournalComponent } from 'app/main/journal/journal.component';
import { JournalResolver } from 'app/main/journal/journal.resolver';
import { PCGComponent } from 'app/main/pcg/pcg.component';
import { PCGResolver } from 'app/main/pcg/pcg.resolver';
import { PlanComponent } from 'app/main/plan/plan.component';
import { PlanResolver } from 'app/main/plan/plan.resolver';
import { PayrollResolver } from 'app/main/payroll/payroll.resolver';
import { ProviderComponent } from 'app/main/provider/provider.component';
import { ProviderResolver } from 'app/main/provider/provider.resolver';

import { ChartsExpensesByCategoryComponent } from './charts/charts-expenses-by-category/charts-expenses-by-category.component';
import { ChartsRevenueByCategoryComponent } from './charts/charts-revenue-by-category/charts-revenue-by-category.component';
import { PayrollComponent } from './payroll/payroll.component';
import { PlComponent } from './p&l/pl.component';
import { PlResolver } from './p&l/pl.resolver';

export const routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      help: 'assets/help/dashboard.md',
      title: 'Tableau de bord',
    },
  },
  {
    path: 'pcg',
    component: PCGComponent,
    canActivate: [AuthGuard],
    resolve: {
      pcg: PCGResolver,
    },
    data: {
      help: 'assets/help/pcg.md',
      title: 'PCG',
    },
  },
  {
    path: 'company/:companyId',
    component: CompanyComponent,
    canActivate: [AuthGuard],
    resolve: {
      company: CompanyResolver,
    },
    data: {
      help: 'assets/help/company.md',
      title: 'Société',
    },
  },
  {
    path: 'pl/:companyId',
    component: PlComponent,
    canActivate: [AuthGuard],
    resolve: {
        pl: PlResolver
    },
    data: {
      help: 'assets/help/pl.md',
      title: 'Profit & Loss',
    },
  },
  {
    path: 'accounting/:companyId',
    component: AccountingComponent,
    canActivate: [AuthGuard],
    resolve: {
      accounting: AccountingResolver,
    },
    data: {
      help: 'assets/help/accounting.md',
      title: 'Comptabilité',
    },
  },
  /** --------------------------------------------------- */
  {
    path: 'payroll/:companyId',
    component: PayrollComponent,
    canActivate: [AuthGuard],
    resolve: {
      payroll: PayrollResolver,
    },
    data: {
      help: 'assets/help/payroll.md',
      title: 'Paye',
    },
  },
  /** --------------------------------------------------- */
  {
    path: 'charts/:companyId',
    component: ChartsComponent,
    canActivate: [AuthGuard],
    resolve: {
      charts: ChartsResolver,
    },
    children: [
      { path: '', redirectTo: 'revenue', pathMatch: 'full' },
      {
        path: 'revenue',
        component: ChartsRevenueComponent,
        data: {
          help: 'assets/help/charts/charts-revenue.md',
          title: "Chiffre d'affaires",
        },
      },
      {
        path: 'revenue-by-category',
        component: ChartsRevenueByCategoryComponent,
        data: {
          help: 'assets/help/charts/charts-revenue.md',
          title: "Chiffre d'affaires par Catégorie",
        },
      },
      {
        path: 'expenses',
        component: ChartsExpensesComponent,
        data: {
          help: 'assets/help/charts/charts-expenses.md',
          title: 'Charges',
        },
      },
      {
        path: 'expenses-by-category',
        component: ChartsExpensesByCategoryComponent,
        data: {
          help: 'assets/help/charts/charts-expenses.md',
          title: 'Charges par Catégorie',
        },
      },
    ],
  },
  {
    path: 'cube/:companyId/grid',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'grid',
      title: 'Cube',
    },
  },
  {
    path: 'cube/:companyId/resultat',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'resultat',
      title: 'Résultat',
    },
  },
  {
    path: 'cube/:companyId/revenue',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'revenue',
      title: "H Chiffre d'Affaires",
    },
  },
  {
    path: 'cube/:companyId/revenue-by-category',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'revenue-by-category',
      title: "H Chiffre d'Affaires par Catégorie",
    },
  },
  {
    path: 'cube/:companyId/expenses',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'expenses',
      title: 'H Charges',
    },
  },
  {
    path: 'cube/:companyId/expenses-by-category',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'expenses-by-category',
      title: 'H Charges par Catégorie',
    },
  },
  {
    path: 'cube/:companyId/equity',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'equity',
      title: 'H Capitaux',
    },
  },
  {
    path: 'cube/:companyId/invest',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'invest',
      title: 'H Invest',
    },
  },
  {
    path: 'cube/:companyId/banks',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'banks',
      title: 'H Banques',
    },
  },
  {
    path: 'cube/:companyId/cash-burn',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'cash-burn',
      title: 'H Cash Burn',
    },
  },
  {
    path: 'cube/:companyId/third-party',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'third-party',
      title: 'H Tiers',
    },
  },
  {
    path: 'cube/:companyId/third-party-2',
    component: CubeComponent,
    canActivate: [AuthGuard],
    resolve: {
      cube: CubeResolver,
    },
    data: {
      help: 'assets/help/cube.md',
      view: 'third-party-2',
      title: 'H Tiers 2',
    },
  },
  {
    path: 'journal/:companyId',
    component: JournalComponent,
    canActivate: [AuthGuard],
    resolve: {
      balance: JournalResolver,
    },
    data: {
      help: 'assets/help/journal.md',
      title: 'Journal',
    },
  },
  {
    path: 'analytics/:companyId',
    component: AnalyticsComponent,
    canActivate: [AuthGuard],
    resolve: {
      balance: AnalyticsResolver,
    },
    data: {
      help: 'assets/help/analytics.md',
      title: 'Analytics',
    },
  },
  {
    path: 'plan/:companyId',
    component: PlanComponent,
    canActivate: [AuthGuard],
    resolve: {
      balance: PlanResolver,
    },
    data: {
      help: 'assets/help/plan.md',
      title: 'Plan',
    },
  },
  {
    path: 'customers/:companyId',
    component: CustomerComponent,
    canActivate: [AuthGuard],
    resolve: {
      balance: CustomerResolver,
    },
    data: {
      help: 'assets/help/customers.md',
      title: 'Clients',
    },
  },
  {
    path: 'providers/:companyId',
    component: ProviderComponent,
    canActivate: [AuthGuard],
    resolve: {
      balance: ProviderResolver,
    },
    data: {
      help: 'assets/help/providers.md',
      title: 'Fournisseurs',
    },
  },
];
